import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cognito-branded-shell min-h-screen bg-gray-50 text-neutral-800 antialiased" }
const _hoisted_2 = { class: "cognito-branded-shell__header relative z-10 flex shrink-0 justify-center border-b border-gray-200 bg-gray-50 px-4 pb-3 pt-6" }
const _hoisted_3 = { class: "cognito-branded-shell__main relative z-0 flex min-h-0 w-full flex-1 flex-col items-center justify-center px-4 pb-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CognitoLogoMark = _resolveComponent("CognitoLogoMark")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_CognitoLogoMark)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}